'use strict'

import Vue from 'vue'
import axios from 'axios'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const config = {
  baseURL: process.env.VUE_APP_BASE_URL,
  timeout: 30 * 1000, // Timeout
  headers: {
    'Access-Control-Allow-Origin': '*'
  }
  // withCredentials: true, // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    console.log(response, 'response')
    if (response.data.code === '0') {
      return response
    } else {
      return Promise.reject(response.data)
    }
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error)
  }
)

export function api (url, params) {
  return _axios.post(url, params)
}

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios

  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $api: {
      get () {
        return api
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
